import { useQuery } from "@tanstack/react-query"
import { useAuth } from "hooks";
import { Partner, PartnerFilterData } from "models";
import { PartnerService } from "services";

export const usePartners = (queryName: string | undefined = undefined) => {
	const { isAdministrator } = useAuth();
	const { data: partners, isFetching, error } = useQuery({
		queryKey: [queryName || 'partners'],
		queryFn: isAdministrator ? PartnerService.getAll : PartnerService.getAllForUser
	})

	const filterFunction = (items: Partner[], filterData: PartnerFilterData) => {
		return items.filter((partner: Partner) => {
			if (filterData.email && !partner.email.toLowerCase().includes(filterData.email.toLowerCase())) {
				return false;
			}
			if (filterData.firstName && !partner.firstName.toLowerCase().includes(filterData.firstName.toLowerCase())) {
				return false;
			}
			if (filterData.lastName && !partner.lastName.toLowerCase().includes(filterData.lastName.toLowerCase())) {
				return false;
			}
			if (filterData.phoneNumber && !partner.phoneNumber.toLowerCase().includes(filterData.phoneNumber.toLowerCase())) {
				return false;
			}
			if (filterData.country && !partner.country.toLowerCase().includes(filterData.country.toLowerCase())) {
				return false;
			}
			if (filterData.mentorId && partner.mentorId !== filterData.mentorId) {
				return false;
			}
			return true;
		});
	};
	return { partners, isFetching, error, filterFunction };
}